import Vue from 'vue'
import VueRouter from 'vue-router'

import Agendamento from './agendamento'
import Atendimento from './atendimento'
import Botao from './botao'
import Cbo from './cbo'
import Classificacao from './classificacao'
import Finalizacao from './finalizacao'
import Local from './local'
import Painel from './painel'
import Pessoa from './pessoa'
import Setor from './setor'
import Totem from './totem'
import User from './user'
import Usuario from './usuario'
import Unidade from './unidade'
import Videos from './video'
import Grupos from './grupo'
import Manuais from './manual'
import ManualGrupos from './manualGrupo'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        Agendamento,
        Atendimento,
        Botao,
        Cbo,
        Classificacao,
        Finalizacao,
        Local,
        Painel,
        Pessoa,
        Setor,
        Totem,
        User,
        Usuario,
        Unidade,
        Videos,
        Grupos,
        Manuais,
        ManualGrupos,
        {
            path: '/',
            name: 'home',
            component: () => import('@/views/Home.vue'),
            meta: {
                pageTitle: 'Home',
                breadcrumb: [
                    {
                        text: 'Home',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '/painel_atendimento/:unidade_id/:atendimento_id',
            name: 'painel_atendimento',
            component: () => import('@/views/PainelAtendimento.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '/error-404',
            name: 'error-404',
            component: () => import('@/views/error/Error404.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '/no-item',
            name: 'no-item',
            component: () => import('@/views/error/NoItem.vue'),
        },
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach((to, from, next) => {
    const terms = localStorage.getItem('accept_terms');
    const authenticated = localStorage.getItem('token');
    let to_splited = to.path.toString().split('/')
    to_splited = to_splited.filter(part => part !== '')

    if (
        !authenticated &&
        (
            !(['/login'].includes(to.path.toString())) &&
            !(['public'].includes(to_splited[0])) &&
            !(['painel_atendimento'].includes(to_splited[0]))
        )
    ) {
        next('/login');

        return true;
    }

    next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router
